import GlobusBlack from '@assets/icons/Globus.png';
import GlobusWhite from '@assets/icons/Globus-White.png';
import styles from './style.module.scss';

interface props {
  fill?: 'black' | 'white';
}

const MainLogo = ({ fill = 'black' }: props) => {
  if (fill === 'black') {
    return <img alt="main" src={GlobusBlack} className={styles.root} />;
  }

  return <img alt="main" src={GlobusWhite} className={styles.root} />;
};

export default MainLogo;
